/**
 * An object mapping environment keys to their corresponding API base URLs.
 *
 * @property {string} '.dev.nextiva' - The base URL for the development environment.
 * @property {string} '.rc.nextiva' - The base URL for the release candidate environment.
 * @property {string} '.nextos.com' - The base URL for the production environment.
 * @property {string} localhost - The base URL for the local development environment.
 */
export const apiMappings = {
  '.dev.nextiva': 'https://api-dev.be.nextiva.xyz',
  '.rc.nextiva': 'https://api-rc.be.nextiva.xyz',
  '.nextos.com': 'https://api.be.nextiva.com',
  localhost: 'http://localhost:8080',
};

/**
 * API Paths
 */
export const argPath = '/public/payment-methods/v1';
